import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MaButtonComponent } from '../../../material-angular/ma-button/ma-button.component';
import { ModalComponent } from '../modal/modal.component';
import { ConfirmService } from './confirm.service';

/** Mount once in the app shell; features ask through {@link ConfirmService}. */
@Component({
  selector: 'ui-confirm-dialog',
  standalone: true,
  imports: [ModalComponent, MaButtonComponent],
  templateUrl: './confirm-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmDialogComponent {
  protected readonly confirm = inject(ConfirmService);
}
